/**
 * Some-steps recipes - Chopping + cooking involved
 * ~15 recipes for when you have moderate energy
 */

const SOME_STEPS_RECIPES = [
  {
    id: 'chicken-stir-fry',
    name: 'Chicken Stir Fry',
    effort: 'some-steps',
    needs: ['chicken', 'veg', 'soy sauce'],
    optional: ['garlic', 'ginger', 'rice', 'sesame oil'],
    description: 'Proper stir fry with sliced chicken',
    tips: 'Slice chicken thin, cook in batches'
  },
  {
    id: 'tacos',
    name: 'Tacos',
    effort: 'some-steps',
    needs: ['tortilla', 'meat', 'onion'],
    optional: ['cheese', 'salsa', 'lettuce', 'sour cream'],
    description: 'Build your own taco night',
    tips: 'Season meat well, warm tortillas'
  },
  {
    id: 'curry-simple',
    name: 'Simple Curry',
    effort: 'some-steps',
    needs: ['protein', 'curry paste', 'coconut milk'],
    optional: ['onion', 'garlic', 'veg', 'rice'],
    description: 'Creamy curry, surprisingly easy',
    tips: 'Fry paste first to release flavors'
  },
  {
    id: 'tomato-soup',
    name: 'Tomato Soup',
    effort: 'some-steps',
    needs: ['tomato', 'onion', 'stock'],
    optional: ['garlic', 'cream', 'basil', 'bread'],
    description: 'Homemade beats canned every time',
    tips: 'Blend smooth or leave chunky'
  },
  {
    id: 'chicken-soup',
    name: 'Chicken Soup',
    effort: 'some-steps',
    needs: ['chicken', 'carrot', 'celery', 'stock'],
    optional: ['noodles', 'onion', 'herbs'],
    description: 'Comfort in a bowl',
    tips: 'Poach chicken in the broth'
  },
  {
    id: 'pasta-carbonara',
    name: 'Pasta Carbonara',
    effort: 'some-steps',
    needs: ['pasta', 'egg', 'bacon', 'cheese'],
    optional: ['garlic', 'black pepper', 'parsley'],
    description: 'Creamy without cream',
    tips: 'Mix eggs off heat to avoid scrambling'
  },
  {
    id: 'fried-chicken',
    name: 'Pan-Fried Chicken',
    effort: 'some-steps',
    needs: ['chicken', 'flour', 'oil'],
    optional: ['spices', 'egg', 'breadcrumbs'],
    description: 'Crispy outside, juicy inside',
    tips: 'Let chicken rest before cutting'
  },
  {
    id: 'beef-tacos',
    name: 'Ground Beef Tacos',
    effort: 'some-steps',
    needs: ['ground beef', 'tortilla', 'taco seasoning'],
    optional: ['cheese', 'lettuce', 'tomato', 'sour cream'],
    description: 'Classic taco Tuesday',
    tips: 'Drain fat after browning'
  },
  {
    id: 'veggie-soup',
    name: 'Vegetable Soup',
    effort: 'some-steps',
    needs: ['veg', 'stock', 'onion'],
    optional: ['potato', 'beans', 'pasta', 'herbs'],
    description: 'Clean out the fridge soup',
    tips: 'Add harder veg first, leafy greens last'
  },
  {
    id: 'salmon-pan',
    name: 'Pan-Seared Salmon',
    effort: 'some-steps',
    needs: ['salmon', 'oil'],
    optional: ['lemon', 'garlic', 'herbs', 'veg'],
    description: 'Restaurant-quality fish at home',
    tips: 'Skin side down first, don\'t move it'
  },
  {
    id: 'burrito-bowl',
    name: 'Burrito Bowl',
    effort: 'some-steps',
    needs: ['rice', 'beans', 'protein'],
    optional: ['cheese', 'salsa', 'avocado', 'corn'],
    description: 'Chipotle at home',
    tips: 'Season rice with lime and cilantro'
  },
  {
    id: 'pasta-aglio-olio',
    name: 'Pasta Aglio e Olio',
    effort: 'some-steps',
    needs: ['pasta', 'garlic', 'olive oil', 'chili flakes'],
    optional: ['parsley', 'parmesan', 'lemon'],
    description: 'Simple Italian, big flavor',
    tips: 'Don\'t burn the garlic - golden only'
  },
  {
    id: 'chicken-fajitas',
    name: 'Chicken Fajitas',
    effort: 'some-steps',
    needs: ['chicken', 'peppers', 'onion', 'tortilla'],
    optional: ['spices', 'sour cream', 'cheese', 'salsa'],
    description: 'Sizzling Tex-Mex favorite',
    tips: 'High heat for charred edges'
  },
  {
    id: 'fried-rice-proper',
    name: 'Proper Fried Rice',
    effort: 'some-steps',
    needs: ['rice', 'egg', 'soy sauce', 'veg'],
    optional: ['shrimp', 'chicken', 'green onion', 'sesame oil'],
    description: 'Takeout-style at home',
    tips: 'Use cold day-old rice, high heat'
  },
  {
    id: 'meatballs',
    name: 'Meatballs in Sauce',
    effort: 'some-steps',
    needs: ['ground beef', 'breadcrumbs', 'egg', 'tomato sauce'],
    optional: ['onion', 'garlic', 'herbs', 'parmesan'],
    description: 'Classic comfort, make extra to freeze',
    tips: 'Don\'t overmix the meat'
  },
  // === ADDITIONAL PROTEIN OPTIONS ===
  {
    id: 'pork-stir-fry',
    name: 'Pork Stir Fry',
    effort: 'some-steps',
    needs: ['pork', 'veg', 'soy sauce', 'garlic'],
    optional: ['ginger', 'rice', 'sesame oil', 'honey'],
    description: 'Sweet and savory pork with veg',
    tips: 'Slice pork against the grain'
  },
  {
    id: 'lamb-curry',
    name: 'Lamb Curry',
    effort: 'some-steps',
    needs: ['lamb', 'curry paste', 'coconut milk', 'onion'],
    optional: ['garlic', 'ginger', 'rice', 'spinach'],
    description: 'Rich and warming curry',
    tips: 'Brown lamb first for deeper flavor'
  },
  {
    id: 'turkey-meatballs',
    name: 'Turkey Meatballs',
    effort: 'some-steps',
    needs: ['ground turkey', 'breadcrumbs', 'egg', 'tomato sauce'],
    optional: ['onion', 'garlic', 'herbs', 'parmesan'],
    description: 'Lighter meatball option',
    tips: 'Add grated onion to keep them moist'
  },
  {
    id: 'tofu-stir-fry',
    name: 'Tofu Stir Fry',
    effort: 'some-steps',
    needs: ['tofu', 'veg', 'soy sauce', 'garlic'],
    optional: ['ginger', 'rice', 'sesame oil', 'chili flakes'],
    description: 'Crispy tofu with vegetables',
    tips: 'Press and cube tofu, fry until golden'
  },
  {
    id: 'lentil-soup',
    name: 'Lentil Soup',
    effort: 'some-steps',
    needs: ['lentils', 'onion', 'carrot', 'stock'],
    optional: ['celery', 'garlic', 'tomato', 'cumin'],
    description: 'Hearty vegan protein soup',
    tips: 'Red lentils break down, green stay whole'
  },
  {
    id: 'shrimp-pasta',
    name: 'Shrimp Pasta',
    effort: 'some-steps',
    needs: ['pasta', 'shrimp', 'garlic', 'olive oil'],
    optional: ['tomato', 'white wine', 'parsley', 'chili flakes'],
    description: 'Quick seafood pasta',
    tips: 'Don\'t overcook shrimp - 2-3 min each side'
  },
  {
    id: 'chickpea-curry',
    name: 'Chickpea Curry',
    effort: 'some-steps',
    needs: ['chickpeas', 'curry paste', 'coconut milk', 'onion'],
    optional: ['garlic', 'spinach', 'rice', 'tomato'],
    description: 'Creamy vegan curry',
    tips: 'Canned chickpeas work great'
  }
];

export default SOME_STEPS_RECIPES;
